import type { RootBlockModel } from '@blocksuite/hive/model';
import { BlockComponent } from '@blocksuite/hive/std';
import { html } from 'lit';

export class MindmapRootBlock extends BlockComponent<RootBlockModel> {
  override render() {
    return html`
      <style>
        .hive-mini-mindmap-root {
          display: block;
          width: 100%;
          height: 100%;

          background-size: 20px 20px;
          background-color: var(--hive-background-primary-color);
          background-image: radial-gradient(
            var(--hive-edgeless-grid-color) 1px,
            var(--hive-background-primary-color) 1px
          );
        }
      </style>
      <div class="hive-mini-mindmap-root">
        ${this.host.renderChildren(this.model)}
      </div>
    `;
  }
}
